import React, { useEffect, useState } from 'react'
import PublicHeader from '../Header/PublicHeader';
import * as jnb from 'react-bootstrap';
import { CommonPageHeading } from '../CommonUtils/CommonHeading/CommonPageHeading';

function StaticPaymentPage() {


    const [currentDateTime,setCurrentDateTime]=useState([])



    useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedTime = `${hours}:${minutes} ${ampm}`;

      setCurrentDateTime(`${day}-${month}-${year} & ${formattedTime}`);
    };

    updateDateTime(); // Initial call

    const intervalId = setInterval(updateDateTime, 60000); // Update every 60 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
    return (
        <>
            <PublicHeader />
            <div className="main_section">  </div>
            <CommonPageHeading heading="Payment Details" />
            <jnb.Container className="outer-page-content-container">
                <div className='text-center mx-5'>

                    <jnb.Row className="pt-1">
                          <div className="d-flex justify-content-center align-items-center">
                                 <div className="table-responsive" style={{ width: '60%' }}>
  <table
    className="table table-bordered table-striped table-hover mb-0 mt-4"
    style={{
      border: '3px solid lightblue',
      width: '100%',
      borderCollapse: 'collapse',
    }}
  >
    <thead>
      <tr>
      <th
  colSpan="2"
  className="text-center"
  style={{
    fontSize: '1.2rem',
    backgroundColor: '7px solid lightblue',
    color: 'black',
    border: '1px solid black', 
  }}
>
  Payment Invoice
</th>

      </tr>
    </thead>
    <tbody>
      <tr>
        <th style={{ width: '50%' }}>Transaction ID</th>
        <td>LBTEST1747029150323</td>
      </tr>
      <tr>
        <th>Amount</th>
        <td>₹ 200/-</td>
      </tr>
      <tr>
        <th>Payment Status</th>
        <td style={{ color: "SUCCESS"=== 'SUCCESS' ? 'green' : 'red' }}>
            SUCCESS
</td>

      </tr>
      <tr>
        <th>Payment Date & Time </th>
        <td>{currentDateTime}</td>
      </tr>
      {/* <tr>
        <th>Payment Time</th>
        <td>{paymentTime}</td>
      </tr> */}
    </tbody>
  </table>
</div>

</div>


                    </jnb.Row>
                </div>
            </jnb.Container>


        </>
    )
}

export default StaticPaymentPage
